import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function search(search:string, page:number, pageSize:number, sort: any): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('searchProduct')
    .setMethod('POST')
    .setProps([{search: search, page: page, pageSize: pageSize, sort: sort}])
    .send();
}
